import gql from 'graphql-tag';

export const GET_LOGBOOK_LIST_BY_PROCESS = gql`
  query ($processId: ID!){
    logbookGetByProcess(process_id: $processId) {
      id
      type
      process_id
      server_id
      thread
      parts {
        time
        type
        message
      }
      partCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/logbook/listByProcess.js